import { usd, signedUsd, tone } from "@/lib/api";

const Tile = ({ label, value, sub, valueClass = "text-slate-100", children, testid, delay }) => (
  <div className="panel p-4 sm:p-5 rise" style={{ animationDelay: `${delay}ms` }} data-testid={testid}>
    <div className="panel-title">{label}</div>
    <div className={`mt-3 font-mono text-2xl font-bold tracking-tight ${valueClass}`}>{value}</div>
    {sub && <div className="mt-1 text-xs text-slate-500 font-mono">{sub}</div>}
    {children}
  </div>
);

export const KpiBar = ({ data }) => {
  const { stats, settings, bot_wallet } = data;
  const quota = settings.trades_per_day;
  const st = settings.source_status || {};
  const live = Object.keys(st).filter((k) => st[k].ok).map((k) => ({ gmgn: "GMGN", axiom: "Axiom", fomo: "FOMO", birdeye: "Birdeye" }[k] || k));
  const sourceLabel = live.length ? live.join(" + ") : settings.trader_source === "manual" ? "Manual list" : "—";
  return (
    <section className="grid grid-cols-2 lg:grid-cols-5 gap-px bg-[#1E293B] border border-[#1E293B]">
      <Tile testid="kpi-total-pnl" label="Total net PnL" value={signedUsd(stats.total_pnl)} valueClass={tone(stats.total_pnl)}
        sub={`${usd(stats.total_invested)} deployed · ${stats.total_trades} trades`} delay={0} />
      <Tile testid="kpi-trades-today" label="Trades today" value={quota ? `${stats.trades_today}/${quota}` : `${stats.trades_today} / ∞`} sub={`$${settings.trade_usd.toFixed(2)} per trade${quota ? "" : " · unlimited"}`} delay={60}>
        {quota > 0 && quota <= 50 && (
          <div className="mt-3 flex gap-1">
            {Array.from({ length: quota }).map((_, i) => (
              <div key={i} className={`h-1.5 flex-1 ${i < stats.trades_today ? "bg-[#14F195]" : "bg-[#1E293B]"}`} />
            ))}
          </div>
        )}
      </Tile>
      <Tile testid="kpi-today-pnl" label="Today PnL" value={signedUsd(stats.today_pnl)} valueClass={tone(stats.today_pnl)}
        sub={`${stats.open_positions} open · value ${usd(stats.total_value)}`} delay={120} />
      <Tile testid="kpi-bot-balance" label="Bot wallet" value={bot_wallet.sol === null ? "—" : `${bot_wallet.sol.toFixed(4)} SOL`}
        sub={`${usd(bot_wallet.usd)} · SOL ${usd(data.sol_price)}`} delay={180} />
      <Tile testid="kpi-source" label="Trader source" value={sourceLabel}
        valueClass={live.length ? "text-[#14F195]" : "text-[#F59E0B]"}
        sub={stats.win_rate === null ? "win rate: no closed trades" : `win rate ${stats.win_rate.toFixed(0)}%`} delay={240} />
    </section>
  );
};
